import type { GuestFieldFlags, GuestFieldTooShort } from '@common/hooks/useGuestFieldErrors';
import type { ZodIssue } from 'zod';
import { GuestFieldFormSchema } from '../types';

const toFlag = (issue: ZodIssue, value: unknown): true | GuestFieldTooShort =>
  issue.code === 'too_small' && typeof value === 'string' && value.length > 0
    ? { type: 'too_small', minimum: Number(issue.minimum) }
    : true;

/**
 * Validates all guests in the array to ensure their guest details meet the required schema.
 * Used to determine if the form is valid before allowing progression to the next step.
 *
 * @param guests - Array of guest objects with guestDetails property
 * @returns true if all guests have valid guest details, false otherwise
 */
export const validateGuestDetails = (guests: any[]): boolean => {
  return guests.every((guest) => GuestFieldFormSchema.safeParse(guest?.guestDetails).success);
};

export const getGuestDetailsIssues = (guestDetails: any): GuestFieldFlags => {
  const result = GuestFieldFormSchema.safeParse(guestDetails);
  const issues: GuestFieldFlags = result.success
    ? {}
    : Object.fromEntries(
        result.error.issues.map((issue) => [
          issue.path[0],
          toFlag(issue, guestDetails?.[issue.path[0]]),
        ])
      );
  if (!guestDetails?.title?.trim()) issues.title = true;
  return issues;
};
